import React, { useState, useEffect } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';

const EditProjectModal = ({ show, onHide, onSubmit, project, organizations }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [organizationId, setOrganizationId] = useState('');

  useEffect(() => {
    if (project) {
      setName(project.name || '');
      setDescription(project.description || '');
      setOrganizationId(project.organizationId || '');
    }
  }, [project]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      name,
      description,
      organizationId: organizationId || null
    });
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton className="bg-light">
        <Modal.Title className="h5 font-weight-bold">Edit Company Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label className="font-weight-bold text-secondary small">Company Name</Form.Label>
            <Form.Control
              type="text"
              required
              value={name}
              onChange={e => setName(e.target.value)}
              placeholder="e.g. ORGANIC LAVENDER DAY SPA"
              className="border-primary shadow-sm"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="font-weight-bold text-secondary small">Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={description}
              onChange={e => setDescription(e.target.value)}
              placeholder="Provide a brief description..."
              className="shadow-sm"
            />
          </Form.Group>

          {organizations && organizations.length > 0 && (
            <Form.Group className="mb-4">
              <Form.Label className="font-weight-bold text-secondary small">Organization Group</Form.Label>
              <Form.Control
                as="select"
                value={organizationId}
                onChange={e => setOrganizationId(e.target.value)}
                className="shadow-sm"
              >
                <option value="">No Organization Group</option>
                {organizations.map(org => (
                  <option key={org._id} value={org._id}>
                    {org.name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          )}

          <div className="d-flex justify-content-end" style={{ gap: '10px' }}>
            <Button variant="secondary" size="sm" onClick={onHide} className="font-weight-bold">
              Cancel
            </Button>
            <Button variant="primary" size="sm" type="submit" className="font-weight-bold shadow-sm">
              Save Changes
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default EditProjectModal;
